"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "start-screen" };
const _hoisted_2 = { class: "start-screen-links" };
const _hoisted_3 = {
    class: "start-screen-link start-screen-link--new-game",
    href: "new-game"
};
const _hoisted_4 = {
    class: "start-screen-link start-screen-link--how-to-play",
    href: "https://github.com/terraforming-mars/terraforming-mars/wiki/Rulebooks",
    target: "_blank"
};
const _hoisted_5 = {
    class: "start-screen-link start-screen-link--cards-list",
    href: "cards",
    target: "_blank"
};
const _hoisted_6 = {
    class: "start-screen-link start-screen-link--board-game",
    href: "https://boardgamegeek.com/boardgame/167791/terraforming-mars",
    target: "_blank"
};
const _hoisted_7 = {
    class: "start-screen-link start-screen-link--about",
    href: "https://github.com/terraforming-mars/terraforming-mars#README",
    target: "_blank"
};
const _hoisted_8 = {
    class: "start-screen-link start-screen-link--changelog",
    href: "https://github.com/terraforming-mars/terraforming-mars/wiki/Changelog",
    target: "_blank"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "start-screen-header start-screen-link--languages" };
const _hoisted_11 = { class: "start-screen-version-cont" };
const _hoisted_12 = { class: "nowrap start-screen-date" };
const _hoisted_13 = { class: "nowrap start-screen-version" };
const _hoisted_14 = { class: "free-floating-preferences-icon" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_language_switcher = (0, vue_1.resolveComponent)("language-switcher");
    const _component_preferences_icon = (0, vue_1.resolveComponent)("preferences-icon");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
            _cache[10] || (_cache[10] = (0, vue_1.createElementVNode)("div", { class: "start-screen-header start-screen-link--title" }, [
                (0, vue_1.createElementVNode)("div", { class: "start-screen-title-top" }, "TERRAFORMING"),
                (0, vue_1.createElementVNode)("div", { class: "start-screen-title-bottom" }, "MARS")
            ], -1)),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                    (0, vue_1.createTextVNode)("New game", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                    (0, vue_1.createTextVNode)("How to Play", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                    (0, vue_1.createTextVNode)("Cards list", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_6, [...(_cache[3] || (_cache[3] = [
                    (0, vue_1.createTextVNode)("Board game", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                    (0, vue_1.createTextVNode)("About us", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                    (0, vue_1.createTextVNode)("Whats new?", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                class: "start-screen-link start-screen-link--chat",
                href: _ctx.DISCORD_INVITE,
                target: "_blank"
            }, [...(_cache[6] || (_cache[6] = [
                    (0, vue_1.createTextVNode)("Join us on Discord", -1)
                ]))], 8, _hoisted_9)), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_10, [
                (0, vue_1.createVNode)(_component_language_switcher),
                (0, vue_1.createElementVNode)("div", _hoisted_11, [
                    (0, vue_1.createElementVNode)("div", _hoisted_12, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[7] || (_cache[7] = [
                                (0, vue_1.createTextVNode)("deployed", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createTextVNode)(": " + (0, vue_1.toDisplayString)(_ctx.raw_settings.builtAt), 1)
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_13, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[8] || (_cache[8] = [
                                (0, vue_1.createTextVNode)("version", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createTextVNode)(": " + (0, vue_1.toDisplayString)(_ctx.raw_settings.head), 1)
                    ])
                ]),
                _cache[9] || (_cache[9] = (0, vue_1.createElementVNode)("div", { class: "source-code" }, [
                    (0, vue_1.createElementVNode)("a", {
                        href: "https://github.com/terraforming-mars/terraforming-mars",
                        target: "_blank",
                        class: "source-code-text"
                    }, [
                        (0, vue_1.createElementVNode)("img", {
                            src: "assets/misc/github.png",
                            class: "source-code-img"
                        }),
                        (0, vue_1.createTextVNode)(" source code ")
                    ])
                ], -1))
            ])
        ])), [
            [_directive_i18n]
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_14, [
            (0, vue_1.createVNode)(_component_preferences_icon)
        ])
    ]));
}
